import * as api from '../api/ai-sales.api';
import {
  MOCK_AGENT, MOCK_CONVERSATIONS, MOCK_FOLLOWUPS, MOCK_KNOWLEDGE, MOCK_LEADS, MOCK_OVERVIEW,
} from '../mocks/ai-sales.mock';
import type { KnowledgeItem, SalesAgentBundle } from '../types/contracts';
import { isAiSalesPreview } from './source';

const wrap = <T>(data: T) => ({ ok: true as const, data });

export function fetchOverview(from?: string, to?: string) {
  return isAiSalesPreview() ? Promise.resolve(wrap(MOCK_OVERVIEW)) : api.fetchAiSalesOverview(from, to);
}
export function fetchAnalytics(from?: string, to?: string) {
  return isAiSalesPreview() ? Promise.resolve(wrap(MOCK_OVERVIEW)) : api.fetchAiSalesAnalytics(from, to);
}
export function fetchConversations() {
  return isAiSalesPreview()
    ? Promise.resolve(wrap({ items: MOCK_CONVERSATIONS, connected_channels: [] as string[] }))
    : api.fetchAiSalesConversations();
}
export function fetchConversation(id: string) {
  if (!isAiSalesPreview()) return api.fetchAiSalesConversation(id);
  const row = MOCK_CONVERSATIONS.find((c) => c.id === id);
  return row ? Promise.resolve(wrap(row)) : Promise.resolve({ ok: false as const, message: 'Conversation not found' });
}
export function fetchLeads(params?: Record<string, string | number | undefined>) {
  return isAiSalesPreview() ? Promise.resolve(wrap({ items: MOCK_LEADS })) : api.fetchAiSalesLeads(params);
}
export function fetchLead(id: string | number) {
  if (!isAiSalesPreview()) return api.fetchAiSalesLead(id);
  const row = MOCK_LEADS.find((l) => String(l.id) === String(id));
  return row ? Promise.resolve(wrap(row)) : Promise.resolve({ ok: false as const, message: 'Lead not found' });
}
export function fetchFollowUps(bucket?: string) {
  return isAiSalesPreview() ? Promise.resolve(wrap({ items: MOCK_FOLLOWUPS })) : api.fetchAiSalesFollowUps(bucket);
}
export function updateFollowUp(id: string | number, payload: Record<string, unknown>) {
  return isAiSalesPreview()
    ? Promise.resolve(wrap({ id, status: String(payload.status ?? 'pending') }))
    : api.patchAiSalesFollowUp(id, payload);
}
export function fetchAgent() {
  return isAiSalesPreview() ? Promise.resolve(wrap(MOCK_AGENT)) : api.fetchAiSalesAgent();
}
export function updateAgent(payload: Partial<SalesAgentBundle>) {
  return isAiSalesPreview() ? Promise.resolve(wrap({ ...MOCK_AGENT, ...payload })) : api.putAiSalesAgent(payload);
}
export function fetchKnowledge(category?: string) {
  if (!isAiSalesPreview()) return api.fetchAiSalesKnowledge(category);
  const items = category ? MOCK_KNOWLEDGE.filter((k) => k.category === category) : MOCK_KNOWLEDGE;
  return Promise.resolve(wrap({ items, pricing_from_subscription: [] as unknown[] }));
}
export function saveKnowledge(item: Partial<KnowledgeItem> & { id?: string | number }) {
  if (isAiSalesPreview()) {
    return Promise.resolve(wrap({ ...item, id: item.id ?? Date.now(), source: 'manual' } as KnowledgeItem));
  }
  return item.id ? api.putAiSalesKnowledge(item.id, item) : api.postAiSalesKnowledge(item);
}
export function removeKnowledge(id: string | number) {
  return isAiSalesPreview() ? Promise.resolve(wrap(null)) : api.deleteAiSalesKnowledge(id);
}
